import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ISeedsState } from "../shared";

import { SEEDS_MODULE_NAME } from "./constants";

const initialState: ISeedsState = {
  searchText: "",
};
export const seedsSlice = createSlice({
  name: SEEDS_MODULE_NAME,
  initialState,
  reducers: {
    setSearchText(state, action: PayloadAction<string>): void {
      state.searchText = action.payload;
    },
  },
});

export const seedsReducer = seedsSlice.reducer;
export const { setSearchText } = seedsSlice.actions;
